// Profile of Alina Tselinina, English. Source of the profile page and of the PDF in this language.
module.exports = {
  headline: 'AI / Software Engineer • Python, R & AWS',
  summary: 'Alina Tselinina is a software engineer with a background in data engineering, applied mathematics and machine learning, now working on AI-powered applications and agentic systems. She has experience in building APIs and data pipelines, modernizing applications through cloud migration and developing ML-backed services. Her focus is connecting LLMs and AI agents with reliable software systems through structured workflows, integrations, testing and iterative evaluation.',
  imageAlt: 'Portrait of Alina Tselinina',
  personal: {
    languages: 'English, Polish',
    programmingLanguages: 'Python, R, SQL, Bash'
  },
  education: [
    {
      period: '2014 - 2017',
      field: 'Studies: Financial and actuarial mathematics',
      institution: 'Adam Mickiewicz University, Poznań',
      degree: 'Degree: Master\'s degree'
    },
    {
      period: '2009 - 2014',
      field: 'Studies: Mathematics',
      institution: 'Belarusian State University, Minsk',
      degree: 'Degree: Bachelor\'s degree'
    }
  ],
  skills: [
    {
      title: 'Programming',
      description: 'Python, R, SQL, Bash'
    },
    {
      title: 'AI and LLMs',
      description: 'Claude, MCP, AI agents, LLM adaptation, model training and evaluation'
    },
    {
      title: 'Cloud and data',
      description: 'AWS (Lambda, EC2, S3, Glue, RDS, Athena, Step Functions), Snowflake'
    },
    {
      title: 'Frameworks and APIs',
      description: 'FastAPI, Flask, Shiny, REST APIs, Swagger, JSON Schema, Jinja, lxml'
    },
    {
      title: 'Data engineering and DevOps',
      description: 'ETL, Airflow, Docker, Git, Linux, CI/CD'
    },
    {
      title: 'Databases and orchestration',
      description: 'PostgreSQL, Camunda'
    },
    {
      title: 'Atlassian Tools',
      description: 'Jira, Bitbucket, Confluence'
    }
  ],
  positions: [
    {
      period: 'Since March 2026',
      title: 'AI / Software Engineer, pAIoneer Labs',
      description: [
        'AI agent engineering, workflow configuration and tool integration.',
        'LLM adaptation, model training and evaluation.',
        'AI-powered application development and integration.',
        'Quantum computing: contributing to software development for quantum applications.'
      ]
    },
    {
      period: 'Since May 2025',
      title: 'Senior Software Developer, Geninvo',
      description: [
        'App development.',
        'Unit and UI test implementation to support application quality.'
      ]
    },
    {
      period: 'November 2022 - February 2025',
      title: 'Senior Python Developer, T-Systems',
      description: [
        'Maintenance and improvement of data pipelines and workflow orchestration.',
        'Development of packages for report automation.'
      ]
    },
    {
      period: 'July 2022 - October 2022',
      title: 'Data Engineer, S&P Global',
      description: [
        'Development and maintenance of ETL pipelines.'
      ]
    },
    {
      period: 'March 2022 - June 2022',
      title: 'Python Developer, DevBridge',
      description: [
        'Design and development of REST APIs and backend services.',
        'Implementation of JSON-processing back-end logic.'
      ]
    },
    {
      period: 'November 2020 - March 2022',
      title: 'Senior Software Developer, Roche',
      description: [
        'Design and development of REST APIs and backend services (proof of concept).',
        'Development and maintenance of ETL pipelines.',
        'Modernization of on-premise applications through AWS migration and rewriting R code in Python.',
        'XML validation and transformation into HTML.',
        'Web application development.'
      ]
    },
    {
      period: 'May 2020 - November 2020',
      title: 'Data Scientist, PSI Polska, Poznań',
      description: [
        'Design and development of REST APIs and backend services with a machine-learning model at the back end.',
        'Development of a customer segmentation model.'
      ]
    },
    {
      period: 'January 2019 - April 2020',
      title: 'Advanced Data Scientist, Analyx, Poznań',
      description: [
        'Web scraping and data pipeline development.',
        'Web application development.',
        'Marketing mix modelling.',
        'Workflow optimization.'
      ]
    },
    {
      period: 'May 2018 - December 2018',
      title: 'Data Scientist, Poznań',
      description: [
        'ETL process development.',
        'Maintenance of Bash scripts.',
        'Client support and ad hoc analysis.'
      ]
    },
    {
      period: 'April 2017 - April 2018',
      title: 'Junior Analyst, Poznań',
      description: [
        'Data analysis and report creation.',
        'Preparation of documentation and presentations.'
      ]
    }
  ]
};
